import React, { Component } from 'react';
import Grid from '../../Utils/GridNominaFiltro';
import moment from 'moment';

class NominaList extends Component{

    render(){
        const { loader, detalle, mostrarDescuentos } = this.props;
        return(
            <div>
                {detalle &&
                <Grid 
                    hover 
                    striped 
                    data={detalle} 
                    loading={loader}
                    footer
                    headerStyle={ { background: 'black' } }
                    mostrarDescuentos = {mostrarDescuentos}
                >
                    <TableHeaderColumn
                        isKey
                        dataField="codigo"
                        width="100"
                        dataAlign='left'
                        dataSort
                        thStyle={
                            {color: 'white' }}
                        tdStyle={
                            {color: 'white' }}
                    >
                        Codigo
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="nombre"
                        dataAlign='left'
                        width="450"
                        dataSort
                        thStyle={
                            {color: 'white' }}
                        tdStyle={
                            {color: 'white' }}
                    >
                        Nombre
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        headerAlign="center"
                        dataAlign='right'
                        dataField="sueldo_base"
                        width="150"
                        dataFormat={(cell, row)=>{
                            return new Intl.NumberFormat("en-US",{minimumFractionDigits: 2}).format(Math.abs(cell));
                        }}
                        dataSort
                        thStyle={
                            {color: 'white'}}
                        tdStyle={
                            {color: 'white'}}
                    >
                        Sueldo
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        headerAlign="center"
                        dataAlign='right'
                        dataField="bonificacion_decreto"
                        width="150"
                        dataFormat={(cell, row)=>{
                            return new Intl.NumberFormat("en-US",{minimumFractionDigits: 2}).format(Math.abs(cell));
                        }}
                        dataSort
                        thStyle={
                            {color: 'white'}}
                        tdStyle={
                            {color: 'white'}}
                    >
                        Bonificación
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        headerAlign="center"
                        dataAlign='right'
                        dataField="totalSueldo"
                        width="150"
                        dataFormat={(cell, row)=>{
                            return new Intl.NumberFormat("en-US",{minimumFractionDigits: 2}).format(Math.abs(cell));
                        }}
                        dataSort
                        thStyle={
                            {color: 'white'}}
                        tdStyle={
                            {color: 'white'}}
                    >
                        Total
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        headerAlign="center"
                        dataAlign='right'
                        dataField="dias"
                        width="150"
                        dataFormat={(cell, row)=>{
                            return new Intl.NumberFormat("en-US",{minimumFractionDigits: 0}).format(cell);
                        }}
                        dataSort
                        thStyle={
                            {color: 'white'}}
                        tdStyle={
                            {color: 'white'}}
                    >
                        Dias
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        headerAlign="center"
                        dataAlign='right'
                        dataField="base"
                        width="150"
                        dataFormat={(cell, row)=>{
                            return new Intl.NumberFormat("en-US",{minimumFractionDigits: 2}).format(Math.abs(cell));
                        }}
                        dataSort
                        thStyle={
                            {color: 'white'}}
                        tdStyle={
                            {color: 'white'}}
                    >
                        Base
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        headerAlign="center"
                        dataAlign='right'
                        dataField="bonificacion"
                        width="150"
                        dataFormat={(cell, row)=>{
                            return new Intl.NumberFormat("en-US",{minimumFractionDigits: 2}).format(Math.abs(cell));
                        }}
                        dataSort
                        thStyle={
                            {color: 'white'}}
                        tdStyle={
                            {color: 'white'}}
                    >
                        Bonificación
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        headerAlign="center"
                        dataAlign='right'
                        dataField="horas_extras"
                        width="150"
                        dataFormat={(cell, row)=>{
                            if (parseFloat(cell) === 0.00) {
                                return ''
                            }else{
                                return new Intl.NumberFormat("en-US",{minimumFractionDigits: 2}).format(Math.abs(cell));
                            }
                        }}
                        dataSort
                        thStyle={
                            {color: 'white'}}
                        tdStyle={
                            {color: 'white'}}
                    >
                        H. extras
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        headerAlign="center"
                        dataAlign='right'
                        dataField="total_devengado"
                        width="150"
                        dataFormat={(cell, row)=>{
                            return new Intl.NumberFormat("en-US",{minimumFractionDigits: 2}).format(Math.abs(cell));
                        }}
                        dataSort
                        thStyle={
                            {color: 'white'}}
                        tdStyle={
                            {color: 'white'}}
                    >
                        Total
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        headerAlign="center"
                        dataAlign='right'
                        dataField="igss"
                        width="150"
                        dataFormat={(cell, row)=>{
                            if (parseFloat(cell) === 0.00) {
                                return ''
                            }else{
                                return '( ' + new Intl.NumberFormat("en-US",{minimumFractionDigits: 2}).format(Math.abs(cell)) + ' )';
                            }
                        }}
                        dataSort
                        thStyle={
                            {color: 'white'}}
                        tdStyle={
                            {color: 'white'}}
                    >
                        Igss
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        headerAlign="center"
                        dataAlign='right'
                        dataField="isr"
                        width="150"
                        dataFormat={(cell, row)=>{
                            if (parseFloat(cell) === 0.00) {
                                return ''
                            }else{
                                return '( ' + new Intl.NumberFormat("en-US",{minimumFractionDigits: 2}).format(Math.abs(cell)) + ' )';
                            }
                        }}
                        dataSort
                        thStyle={
                            {color: 'white'}}
                        tdStyle={
                            {color: 'white'}}
                    >
                        ISR
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        headerAlign="center"
                        dataAlign='right'
                        dataField="descuentos"
                        width="150"
                        dataFormat={(cell, row)=>{
                            if (parseFloat(cell) === 0.00) {
                                return ''
                            }else{
                                return '( ' + new Intl.NumberFormat("en-US",{minimumFractionDigits: 2}).format(Math.abs(cell)) + ' )';
                            }
                        }}
                        dataSort
                        thStyle={
                            {color: 'white'}}
                        tdStyle={
                            {color: 'white'}}
                    >
                        Otros
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        headerAlign="center"
                        dataAlign='right'
                        dataField="judicial"
                        width="150"
                        dataFormat={(cell, row)=>{
                            if (parseFloat(cell) === 0.00) {
                                return ''
                            }else{
                                return '( ' + new Intl.NumberFormat("en-US",{minimumFractionDigits: 2}).format(Math.abs(cell)) + ' )';
                            }
                        }}
                        dataSort
                        thStyle={
                            {color: 'white'}}
                        tdStyle={
                            {color: 'white'}}
                    >
                        Judicial
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        headerAlign="center"
                        dataAlign='right'
                        dataField="total_descuentos"
                        width="200"
                        dataFormat={(cell, row)=>{
                            if (parseFloat(cell) === 0.00) {
                                return new Intl.NumberFormat("en-US",{minimumFractionDigits: 2}).format(Math.abs(cell));
                            }else{
                                return '( ' + new Intl.NumberFormat("en-US",{minimumFractionDigits: 2}).format(Math.abs(cell)) + ' )';
                            }
                        }}
                        dataSort
                        thStyle={
                            {color: 'white'}}
                        tdStyle={
                            {color: 'white'}}
                    >
                        Total descuentos
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        headerAlign="center"
                        dataAlign='right'
                        dataField="liquido"
                        width="150"
                        dataFormat={(cell, row)=>{
                            if (parseFloat(cell) < 0.00) {
                                return '( ' + new Intl.NumberFormat("en-US",{minimumFractionDigits: 2}).format(Math.abs(cell)) + ' )';
                            }else{
                                return new Intl.NumberFormat("en-US",{minimumFractionDigits: 2}).format(Math.abs(cell));
                            }
                        }}
                        dataSort
                        thStyle={
                            {color: 'white'}}
                        tdStyle={
                            {color: 'white'}}
                    >
                        Liquido
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="fecha_baja_suspension"
                        headerAlign="center"
                        width="180"
                        dataAlign='right'
                        dataSort
                        dataFormat={(cell, row)=>{
                            if (cell !== null) {
                                return moment(cell).format("DD/MM/YYYY");
                            }
                        }}
                        thStyle={
                            {color: 'white'}}
                        tdStyle={
                            {color: 'white'}}
                    >
                        Fecha suspensión
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="fecha_alta_suspension"
                        headerAlign="center"
                        width="180"
                        dataAlign='right'
                        dataSort
                        dataFormat={(cell, row)=>{
                            if (cell !== null) {
                                return moment(cell).format("DD/MM/YYYY");
                            }
                        }}
                        thStyle={
                            {color: 'white'}}
                        tdStyle={
                            {color: 'white'}}
                    >
                        Fecha alta
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="dias_suspension"
                        headerAlign="center"
                        width="180"
                        dataAlign='right'
                        dataSort
                        thStyle={
                            {color: 'white'}}
                        tdStyle={
                            {color: 'white'}}
                    >
                        Dias suspendidos
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="fechaAlta"
                        headerAlign="center"
                        width="180"
                        dataAlign='right'
                        dataSort
                        dataFormat={(cell, row)=>{
                            if (cell !== null) {
                                return moment(cell).format("DD/MM/YYYY");
                            }
                        }}
                        thStyle={
                            {color: 'white'}}
                        tdStyle={
                            {color: 'white'}}
                    >
                        Fecha ingreso
                    </TableHeaderColumn>
                </Grid>
                }
            </div>
        );
    }
}

export default NominaList;
